"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const MenuItem = ({ label, path, cartCount = null }) => {
  const pathname = usePathname();
  const href = path || "/";
  const isActive = typeof path === "string" && pathname === path;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const showBadge = mounted && cartCount > 0;

  return (
    <Link
      href={href}
      className={`pb-2 lg:pb-0 border-b-2 border-transparent transition-[border-color,opacity] duration-300
        text-[13px] font-medium flex
        ${isActive ? '!text-primary !border-primary' : ''}
        ${showBadge ? 'relative' : ''}`}
    >
      {label}
      {showBadge && (
        <span className="absolute block w-5 h-5 bg-primary text-white rounded-full text-center leading-[21px] text-[13px] -mt-2 -top-0.5 -right-[18px]">
          {cartCount}
        </span>
      )}
    </Link>
  );
};

export default MenuItem;
